import {
  Box,
  Center,
  ChakraProps,
  Heading,
  ListItem,
  Text,
  UnorderedList,
  VStack,
} from '@chakra-ui/react';

interface Props {
  title: string;
  description: string;
  features: Array<{ feature: string }>;
  color: ChakraProps['bg'];
}

export const BenefitCard = (props: Props) => {
  const { title, description, features, color } = props;

  return (
    <Box rounded="md" bg="white" shadow="md">
      <Center w="full" py="1.75rem" bg={color} rounded="md" shadow="md">
        <Heading textAlign="center" color="white">
          {title}
        </Heading>
      </Center>

      <VStack p="3rem 2rem" spacing="1.25rem" align="flex-start">
        <Text maxW={['unset', 'unset', '24rem']}>{description}</Text>

        <UnorderedList alignSelf="flex-start" pl="1.5rem" spacing="0.5rem">
          {features.map(({ feature }) => (
            <ListItem key={feature}>{feature}</ListItem>
          ))}
        </UnorderedList>
      </VStack>
    </Box>
  );
};
